import { updateFieldValue } from "./payloadRows";

const normalizeCode = (value: unknown): string => {
  if (value == null) {
    return "";
  }

  if (typeof value === "object") {
    if (Array.isArray(value)) {
      return "";
    }

    const record = value as Record<string, unknown>;
    for (const key of [
      "Type",
      "Player Type",
      "Rate Type",
      "Name",
      "name",
      "value",
    ]) {
      if (record[key] != null && String(record[key]).trim() !== "") {
        return normalizeCode(record[key]);
      }
    }
    return "";
  }

  const str = String(updateFieldValue(value)).trim();
  if (!str || str === "[object Object]") {
    return "";
  }

  return str;
};

/** Expands strings, arrays, and legacy bracket lists into individual codes. */
export const readLinkedValues = (value: unknown): string[] => {
  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(readLinkedValues);
  }

  if (typeof value === "object") {
    const code = normalizeCode(value);
    return code ? [code] : [];
  }

  const str = String(value).trim();
  if (!str || str === "[]") {
    return [];
  }

  if (str.startsWith("[") && str.endsWith("]")) {
    const inner = str.slice(1, -1).trim();
    if (!inner) {
      return [];
    }
    return inner
      .split(",")
      .map((part) => normalizeCode(part.trim()))
      .filter(Boolean);
  }

  if (str.includes(",")) {
    return str
      .split(",")
      .map((part) => normalizeCode(part.trim()))
      .filter(Boolean);
  }

  const code = normalizeCode(str);
  return code ? [code] : [];
};

export const serializeUniqueCodes = (values: string[]): string => {
  const seen = new Set<string>();
  const ordered: string[] = [];

  for (const value of values) {
    const code = normalizeCode(value);
    if (code && !seen.has(code)) {
      seen.add(code);
      ordered.push(code);
    }
  }

  return ordered.join(",");
};
